module.exports = __webpack_public_path__ + "img/0x7af173f350d916358af3e218bdf2178494beb748.bcc65e59.png";